import Switch from "pages/business/Subscription/Switch";
import { useEffect, useState } from "react";
import RenderInput from "components/BasicInputs/RenderInput";
import BasicTextInput from "components/BasicInputs/BasicTextInput";

interface Option {
  title: string;
  active: boolean;
  val?: any;
  input?: FormInput;
  onChange?: ({ val, active }: { val: any; active: boolean }) => void;
}

export default function OptionalInput(props: Option) {
  const [state, setState] = useState<{ active: boolean; val?: any }>({
    active: props.active,
    val: props.val,
  });
  useEffect(() => {
    setState((x) => ({ ...x, val: props.val, active: props.active }));
  }, [props.active, props.val]);

  function handleChange(v: any) {
    setState((x) => ({ ...x, val: v }));
    props.onChange && props.onChange({ val: v, active: state.active });
  }

  return (
    <div className="flex gap-4 items-center w-full">
      <div className="flex items-center gap-3 select-none min-w-[150px]">
        <Switch
          onChange={(a) => {
            setState((x) => ({ ...x, active: a }));
            props.onChange && props.onChange({ val: state.val, active: a });
          }}
          active={state.active}
          size={2}
        />
        <span className="text-dark-3">{props.title}</span>
      </div>
      {state.active ? (
        <RenderInput
          {...(props.input || { name: props.title, type: "text" })}
          {...(props.input?.type === "cond" ? { onchange: handleChange } : { onChange: handleChange })}
          inputProps={{
            ...(typeof state.val === "object" ? state.val : { val: state.val }),
            type: "price",
            disabled: !state.active,
            autoComplete: "off",
            ...props.input?.inputProps,
          }}
          containerClassName="w-full"
        />
      ) : (
        <div className="w-full">
          <BasicTextInput disabled />
        </div>
      )}
    </div>
  );
}
